var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:_vm.inputClass,on:{"click":_vm.onBackButtonClicked}},[_vm._v(_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }